export const REPORT_TYPE_VALUES = ["engineer", "creative"] as const;

export type ReaderReportType = (typeof REPORT_TYPE_VALUES)[number];

const DEFAULT_REPORT_TYPE: ReaderReportType = "engineer";

const isReaderReportType = (value: string): value is ReaderReportType => {
  return REPORT_TYPE_VALUES.some((type) => type === value);
};

export const parseReaderReportType = (
  value: string
): ReaderReportType | null => {
  const normalized = value?.toLowerCase() ?? "";

  if (normalized.length > 0 && isReaderReportType(normalized)) {
    return normalized;
  }

  return null;
};

export const getReaderReportType = (): ReaderReportType => {
  const raw = process.env.READER_REPORT_TYPE?.toLowerCase() ?? "";

  if (raw.length > 0 && isReaderReportType(raw)) {
    return raw;
  }

  return DEFAULT_REPORT_TYPE;
};

export const getReaderReportLabel = ({
  reportType,
}: {
  reportType: ReaderReportType;
}): string => {
  switch (reportType) {
    case "creative":
      return "Creative";
    case "engineer":
      return "Engineer";
    default:
      throw new Error(`Invalid report type: ${reportType}`);
  }
};
